/**
 * \@docs-private
 * @param {?} type
 * @return {?}
 */
export function getMatInputUnsupportedTypeError(type) {
    return Error("Input type \"" + type + "\" isn't supported by matInput.");
}
//# sourceMappingURL=input-errors.js.map